<template lang="pug">
  v-toolbar(color="white", flat)
    v-toolbar-title.hidden-xs-only {{ name }} #[span (записей: {{ rowCount }})]
    v-btn(icon,
      @click.prevent="openFilterFieldsForm",
      color="primary").mx-3
      v-icon filter_list
    v-btn(icon @click="openInfoPopup")
      v-icon(large color="primary") help_outline
    v-spacer
    v-flex(xs12 sm6 md6 lg3)
      v-text-field(
        clearable
        flat
        solo
        placeholder="Поиск",
        append-icon="search",
        @click:append="searchMethod",
        @keyup.enter="searchMethod",
        v-model="searchValue",
        type="text")
    v-toolbar-items(v-if="havePermission").hidden-sm-and-down
      v-btn(color="success",
        style="height: 44px;padding: 0 16px;",
        @click.prevent="addNewRecord").mx-2
        v-icon.mr-2 add
        span Запись
      // file-upload(
        ref="upload",
        style="height: 44px;padding: 0 16px;",
        class="v-btn uploadBtn",
        post-action="/upload/post",
        @input-file="inputFile",
        v-model="files").mx-2
        v-icon(color="white").mr-2 file_upload
        span Excel
    v-btn(icon, @click.prevent="close").xs-close-btn
      v-icon close
</template>

<script>
export default {
  name: 'ToolbarView',
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: () => ({
    searchValue: '',
    files: []
  }),
  watch: {
    searchValue(value) {
      this.$emit('search-value', value)
    }
  },
  computed: {
    rowCount() {
      return this.$store.getters.rowCount
    },
    havePermission() {
      return this.$store.state.db.dbRecordsList.edit
    },
    formId() {
      return this.$store.state.db.excelId
    }
  },
  methods: {
    openInfoPopup() {
      this.$emit('open-info-popup')
    },
    openFilterFieldsForm() {
      this.$emit('open-filters-form')
    },
    searchMethod() {
      this.$emit('get-search', 1)
    },
    addNewRecord() {
      this.$emit('add-new-record')
    },
    close() {
      this.$emit('close-modal')
    },
    // inputFile() {
    //   this.$emit('input-file', this.files[0])
    // },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        let file = newFile.file
        const formData = new FormData()
        formData.append('file', file)
        formData.append('formId', this.formId)
        this.$store.dispatch('SEND_EXCEL_FILE', formData).then(() => {
          this.$store.dispatch('GET_DB_RECORDS_LIST', { id: this.formId })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-toolbar {
  border-bottom: 1px solid #c3c3c3 !important;
  &__title {
    span {
      color: grey;
      font-size: 1rem;
      font-weight: 400;
    }
  }
  &__items {
    .v-btn {
      border-radius: 4px;
      &.uploadBtn {
        position: relative;
        display: flex !important;
        background: #5ab300;
        color: #fff;
      }
    }
  }
  .v-text-field {
    padding-top: 8px;
    margin-right: 8px;
  }
}
@media only screen and (max-width: 600px) {
  .v-toolbar {
    .xs-close-btn {
      color: #007bff !important;
      margin-right: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DataBase/Common/ToolbarView.vue